import { Campaign, UserInDetails } from '@hub/shared'
import OverlayContentVideo from '@src/components/overlay-content-video/overlay-content-video.component'
import { HTMLAttributes, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './card-to-upload-video.component.scoped.scss'
import Body from './components/body'
import ButtonSend from './components/button-send'
import Heading from './components/heading'

interface CardToUploadVideoProps extends React.PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  campaign: Campaign
  userInCampaign: UserInDetails
  fetchPosts: () => Promise<void>
}

const CardToUploadVideo = ({ children = null, campaign, userInCampaign, fetchPosts }: CardToUploadVideoProps) => {
  const [openOverlay, setOpenOverlay] = useState(false)
  const [t] = useTranslation('cardToUploadVideo')
  return (
    <div className="card-to-upload-content" style={{ backgroundColor: 'var(--background)' }}>
      {children || (
        <div className="wrapper-card-to-upload-content">
          <Heading>{t('title')}</Heading>
          <Body>{t('body')}</Body>
          <ButtonSend onClick={() => setOpenOverlay(true)}>{t('textButton')}</ButtonSend>
          <OverlayContentVideo
            open={openOverlay}
            onOpen={setOpenOverlay}
            campaign={campaign}
            userInCampaign={userInCampaign}
            fetchPosts={fetchPosts}
          />
        </div>
      )}
    </div>
  )
}

CardToUploadVideo.Heading = Heading
CardToUploadVideo.Body = Body
CardToUploadVideo.Button = ButtonSend

export default CardToUploadVideo
